import {ISFInfomeetingData, IMarketData} from '../interfaces';
import {differenceInMinutes, isWithinInterval, differenceInWeeks} from 'date-fns';
// @ts-ignore
import {MARKETS_LIST} from '~/central-scripts/central-const'

export const infomeetingTypes: { infomeetings: string[], events: string[] } = {
  infomeetings: [
    'Information meeting',
    'Orientation meeting',
    'Online webinar',
    'Interview leader training',
    'Preparation meeting camp',
  ],
  events: [
    'Booking engagement events'
  ]
}

const getMarketLocale = (marketCode: string) => {
  return Object.values(MARKETS_LIST).reduce((acc, market: any) => {
    if (marketCode.includes(market.cms)) {
      acc = market.locale
    }
    return acc
  }, []) ?? 'en'
}

const getDate = (data: ISFInfomeetingData) => {
  try {
    return new Date(data.start_Date_Time__c);
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.warn('Date data not found');
    throw new Error('data not valid')
  }
}

const getEventDate = (data: ISFInfomeetingData, market: string) => {
  const locale = getMarketLocale(market)
  return {
    // @ts-ignore
    big: new Date(Date.parse(data.start_Date_Time__c)).toLocaleDateString(locale, {
      month: 'short',
      day: 'numeric',
    }),
    // @ts-ignore
    small: new Date(Date.parse(data.start_Date_Time__c)).toLocaleDateString(locale, {
      weekday: 'long',
      hour: 'numeric',
      minute: 'numeric',
      hour12: false
    })
  }
}

const mergeMonth = (data: ISFInfomeetingData, market: string) => {
  /**
   * Merges date data from different sources into one specific format
   * More information about the date format can be seen here: https://date-fns.org/v2.11.1/docs/format
   */
  try {
    const locale = getMarketLocale(market)
    const options = {weekday: 'long', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', hour12: false};
    // @ts-ignore
    return new Date(Date.parse(data.start_Date_Time__c)).toLocaleDateString(locale, options)
  } catch (e) {
    throw new Error('data not valid')
  }
}

const mergeDuration = (data: ISFInfomeetingData) => {
  try {
    return differenceInMinutes(
      new Date(data.end_Date_Time__c),
      new Date(data.start_Date_Time__c)
    ) + 'min';
  } catch (e) {
    throw new Error('Duration data not found')
  }
}

const isLive = (dateStart: Date, dateEnd: Date) => {
  try {
    return isWithinInterval(
      new Date(Date.now()),
      {start: dateStart, end: dateEnd}
    );
  } catch (e) {
    throw new Error(e)
  }
}

export const isInfomeetingLive = (data: ISFInfomeetingData) => {
  try {
    return isLive(
      new Date(data.start_Date_Time__c),
      new Date(data.end_Date_Time__c)
    );
  } catch (e) {
    throw new Error('data is not valid')
  }
}

export const mergeMarketData = (market: string, data: Array<ISFInfomeetingData>): Array<IMarketData> => {
  try {
    return data.reduce((acc, curr: ISFInfomeetingData) => {
      return [
        ...acc,
        {
          id: curr.id,
          title: curr.topic__c,
          date: mergeMonth(curr, market),
          description: curr.additional_Information__c,
          type: curr.meeting_Type__c,
          duration: mergeDuration(curr),
          isLive: isInfomeetingLive(curr),
          differenceInWeeks: differenceInWeeksFromNow(getDate(curr)),
          eventDate: getEventDate(curr, market),
          eventLocation: curr.meeting_Place__c ?? '',
          offlineAddress: curr.location_Type__c === 'Offline' ? {
            street: (curr as ISFInfomeetingData).street__c ?? '',
            city: (curr as ISFInfomeetingData).city__c ?? '',
            postalCode: (curr as ISFInfomeetingData).zip_Postal_Code__c ?? '',
          } : null
        }
      ];
    }, [] as Array<any>)
  } catch (e) {
    throw new Error('data not valid')
  }
}

export const differenceInWeeksFromNow = (date: Date) => {
  try {
    const now = new Date(Date.now());
    return differenceInWeeks(date, now);
  } catch (e) {
    throw new Error(e)
  }
}
